<template>
  <!-- The Outer Div is now a Drop Zone -->
  <div class="upload-container" :class="{ 'drag-active': isDragging }" @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave" @drop.prevent="handleDrop">

    <!-- Hidden File Input (Click functionality) -->
    <input type="file" ref="fileInput" style="display: none" @change="handleFileChange"
      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" />

    <!-- Fixed Icons: replaced file-check (pro) with check (free) -->
    <b-button size="sm" style="min-width: 35px;"
      :variant="hasPendingFile ? 'warning' : (hasFile ? 'success' : 'outline-primary')" @click="$refs.fileInput.click()"
      v-b-tooltip.hover :title="hasPendingFile ? 'File ready to save' : (hasFile ? 'Replace File' : 'Upload File')">
      <font-awesome-icon v-if="hasPendingFile" icon="clock"/>
      <font-awesome-icon v-else-if="hasFile" icon="check"/>
      <font-awesome-icon v-else icon="upload"/>
    </b-button>

    <!-- External Link -->
    <a v-if="hasFile" :href="fileUrl" target="_blank" class="ml-2">
      <font-awesome-icon :icon="['fas', 'external-link-alt']" />
    </a>
  </div>
</template>

<script>
export default {
  props: ['row'],
  data() {
    return {
      isDragging: false
    };
  },
  computed: {
    hasFile() {
      return this.row.mls_attachment_url && this.row.mls_attachment_url !== "-" && this.row.mls_attachment_url !== "null";;
    },
    hasPendingFile() {
      return !!this.row.pending_file;
    },
    fileUrl() {
      return this.row.mls_attachment_url;
    }
  },
  methods: {
    // 1. Handle Click Selection
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) this.processFile(file);
      event.target.value = '';
    },

    // 2. Handle Drag and Drop
    onDragOver() {
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    handleDrop(event) {
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      if (file) this.processFile(file);
    },

    // 3. Centralized Process helper
    processFile(file) {
      const allowedTypes = ['.pdf', '.jpg', '.jpeg', '.png', '.doc', '.docx'];
      const extension = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();

      if (!allowedTypes.includes(`.${extension}`)) {
        this.$bvToast.toast("Invalid file type", { variant: "danger" });
        return;
      }

      // Emit to parent (MlsTableComponent)
      this.$emit('file-selected', file);
    }
  }
};
</script>

<style scoped>
.upload-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: 2px dashed transparent;
  transition: all 0.3s ease;
  border-radius: 4px;
  min-height: 40px;
  min-width: 80px;
}

/* Visual feedback when dragging a file over the cell */
.drag-active {
  border-color: #0b36dc;
  background-color: rgba(11, 54, 220, 0.05);
  transform: scale(1.1);
}
</style>
